import { ct as o, cva as c, crv as r } from "@/styled-system/css";
const t = {
  color: o("Anchor.colors.onImpact.default"),
  _hover: {
    color: o("Anchor.colors.onImpact.hover"),
    textDecoration: o("Anchor.font.textDecoration.hover")
  },
  _focusVisible: { color: o("Anchor.colors.onImpact.focus") },
  _active: { color: o("Anchor.colors.onImpact.active") },
  _visited: { color: o("Anchor.colors.onImpact.visited") }
}, n = c({
  base: {
    cursor: "pointer",
    fontFamily: "inherit",
    fontSize: "inherit",
    fontWeight: "inherit",
    lineHeight: "inherit",
    textDecoration: o("Anchor.font.textDecoration.default"),
    color: o("Anchor.colors.default"),
    _hover: { color: o("Anchor.colors.hover") },
    _focusVisible: { color: o("Anchor.colors.focus") },
    _active: { color: o("Anchor.colors.pressed") },
    _visited: { color: o("Anchor.colors.visited") },
    focusOutline: !0
  },
  variants: {
    ...r("onImpact", {
      true: t,
      false: {}
    })
  }
});
export {
  n as anchorRecipe
};
//# sourceMappingURL=anchor.styles.js.map
